import React from 'react';
import Anchor from '@fuww/library/src/Anchor';
import PropTypes from 'prop-types';
import { FullWidthImageContainer }
from '@fuww/library/src/Card';
import { List } from '@fuww/library/src/List';
import LatestJobsContent, { LatestJobsListItem }
from '@fuww/library/src/List/LatestJobs';
import Label from '@fuww/library/src/Label';
import camelCase from 'lodash/camelCase';
import { useSiteContext } from '../../SiteContext';
import LinkAndAnchor from '../../LinkAndAnchor';
import Image from '../../Image';
import getJobsRoute from '../../../lib/getJobsRoute';

const JobLinks = ({
  title,
  jobs,
  className,
  categoryParam,
  placeholder,
  src,
  srcSet,
  sizes,
}) => {
  const { jobsLocale } = useSiteContext();

  return (
    <>
      <LinkAndAnchor
        route={getJobsRoute(null, jobsLocale)}
        params={{ categoryParam }}
      >
        <FullWidthImageContainer withPageMargins>
          <Image
            placeholder={placeholder}
            src={src}
            srcSet={srcSet}
            alt={title}
            width="100%"
            height="auto"
            sizes={sizes}
          />
          <Label
            className={className}
          >
            {title}
          </Label>
        </FullWidthImageContainer>
      </LinkAndAnchor>
      <List>
        {jobs.map(({
          id, title: jobTitle, city, company: { displayName }, urls,
        }) => (
          <LatestJobsListItem key={id}>
            <Anchor
              href={urls[camelCase(jobsLocale)]}
              styled
            >
              <LatestJobsContent
                title={jobTitle}
                city={city}
                companyName={displayName}
              />
            </Anchor>
          </LatestJobsListItem>
        ))}
      </List>
    </>
  );
};

JobLinks.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  className: PropTypes.string,
  categoryParam: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
};

JobLinks.defaultProps = {
  jobs: [],
  title: '',
  className: null,
  categoryParam: null,
};

export default JobLinks;
